import moment from "moment"
import { useEffect, useState } from "react"
import { dictionaryCRUD } from "../../../../actions/dictionary"


export const OtherDetail = (props) => {

  const {data, step3, setStep3, step4, setStep4} = props

  const [marit, setMarit] = useState(null)
  const [economic, setEconomic] = useState(null)
  const [literac, setLiterac] = useState(null)
  const [education, setEducation] = useState(null)
  const [health, setHealth] = useState(null)
  const [disability, setDisability] = useState(null)
  const [nutrition, setNutrition] = useState(null)
  const [resident, setResident] = useState(null)
  const [mosquito, setMosquito] = useState(null)
  const [vacci, setVacci] = useState(null)

  useEffect(() => {
    if (!data) return;

    setTimeout(() => {
      if (data.dictionary_marital_status) {
        dictionaryCRUD.loadDictionaryItemById(data.dictionary_marital_status).then((resp) => {
          setMarit(resp.data && resp.data.dictionary_item_name_en)
        })
      }
      if (data.dictionary_economic_activity) {
        dictionaryCRUD.loadDictionaryItemById(data.dictionary_economic_activity).then((resp) => {
          setEconomic(resp.data && resp.data.dictionary_item_name_en)
        })
      }
      if (data.dictionary_literacy_level) {
        dictionaryCRUD.loadDictionaryItemById(data.dictionary_literacy_level).then((resp) => {
          setLiterac(resp.data && resp.data.dictionary_item_name_en)
        })
      }
      if (data.dictionary_education_level) {
        dictionaryCRUD.loadDictionaryItemById(data.dictionary_education_level).then((resp) => {
          setEducation(resp.data && resp.data.dictionary_item_name_en)
        })
      }
      if (data.dictionary_health_status) {
        dictionaryCRUD.loadDictionaryItemById(data.dictionary_health_status).then((resp) => {
          setHealth(resp.data && resp.data.dictionary_item_name_en)
        })
      }
      if (data.dictionary_disability_status) {
        dictionaryCRUD.loadDictionaryItemById(data.dictionary_disability_status).then((resp) => {
          setDisability(resp.data && resp.data.dictionary_item_name_en)
        })
      }
      if (data.dictionary_nutrition_status) {
        dictionaryCRUD.loadDictionaryItemById(data.dictionary_nutrition_status).then((resp) => {
          setNutrition(resp.data && resp.data.dictionary_item_name_en)
        })
      }
      if (data.dictionary_residential_status) {
        dictionaryCRUD.loadDictionaryItemById(data.dictionary_residential_status).then((resp) => {
          setResident(resp.data && resp.data.dictionary_item_name_en)
        })
      }
      if (data.dictionary_mosquito_net_status) {
        dictionaryCRUD.loadDictionaryItemById(data.dictionary_mosquito_net_status).then((resp) => {
          setMosquito(resp.data && resp.data.dictionary_item_name_en)
        })
      }
      if (data.dictionary_vaccination_info) {
        dictionaryCRUD.loadDictionaryItemById(data.dictionary_vaccination_info).then((resp) => {
          setVacci(resp.data && resp.data.dictionary_item_name_en)
        })
      }
    },500)
  },[data])

  return (
    <>
      <div>
        <div className="row">
            <div className="col-lg-4 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Marital Status</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-email-input" value={marit ? (marit).toUpperCase() : 'N/A'}  readOnly/>
                </div>
            </div>
            <div className="col-lg-4 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Economic Activity</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-username-input" value={economic ? (economic).toUpperCase() : 'N/A'}  readOnly/>
                </div>
            </div>
            <div className="col-lg-4 col-sm-12">
              <div className="mb-3">
                <label className="form-label" >Literacy Level</label>
                <input type="text" className="form-control border-dashed" id="steparrow-gen-info-password-input" value={literac ? (literac).toUpperCase() : 'N/A'} readOnly/>
              </div>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-4 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Education Level</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-email-input" value={education ? (education).toUpperCase() : 'N/A'} readOnly/>
                </div>
            </div>
            <div className="col-lg-4 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Health Status</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-username-input" value={health ? (health).toUpperCase() : 'N/A'} readOnly/>
                </div>
            </div>
            <div className="col-lg-4 col-sm-12">
              <div className="mb-3">
                <label className="form-label" >Disability</label>
                <input type="text" className="form-control border-dashed" id="steparrow-gen-info-password-input" value={disability ? (disability).toUpperCase() : 'N/A'} readOnly/>
              </div>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-6 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Nutrition Status</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-email-input" value={nutrition ? (nutrition).toUpperCase() : 'N/A'} readOnly/>
                </div>
            </div>
            <div className="col-lg-6 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Vaccination Information</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-username-input" value={vacci ? (vacci).toUpperCase() : 'N/A'} readOnly/>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-6 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Mosquito Net Status</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-username-input" value={mosquito ? (mosquito).toUpperCase() : 'N/A'} readOnly/>
                </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="mb-3">
                <label className="form-label" >Residential Status</label>
                <input type="text" className="form-control border-dashed" id="steparrow-gen-info-password-input" value={resident ? (resident).toUpperCase() : 'N/A'} readOnly/>
              </div>
            </div>
        </div>
      </div>
      <div className="d-flex align-items-start gap-3 mt-4">
      <button type="button" class="btn btn-light btn-label" onClick={() => setStep3(!step3)} ><i class="bi bi-chevron-double-left label-icon align-middle fs-16 me-2"></i> Previous</button>
      {data.is_dead &&
      <button type="button" class="btn btn-success btn-label right ms-auto" onClick={() => setStep4(!step4)}><i className="bi bi-chevron-double-right label-icon align-middle fs-16 ms-2"></i>Next</button>
      }
      </div>
    </>
  )

}